<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="28" height="28" rx="14" fill="white" />
    <g clip-path="url(#clip0_2111_53703)">
      <path
        d="M12.3336 16.6433L19.4045 9.57164C19.7299 9.24619 20.2575 9.24609 20.583 9.5714V9.5714C20.9087 9.89686 20.9088 10.4247 20.5832 10.7503L13.0407 18.2928C12.6502 18.6833 12.017 18.6833 11.6265 18.2928L7.61944 14.2858C7.29405 13.9604 7.29405 13.4328 7.61944 13.1074V13.1074C7.94483 12.782 8.47239 12.782 8.79777 13.1074L12.3336 16.6433Z"
        fill="#1719DA" />
    </g>
    <defs>
      <clipPath id="clip0_2111_53703">
        <rect width="20" height="20" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: ["color"]
}
</script>